import React, { useRef } from "react";
import styles from "./TableRow.module.css";
import { useHistory } from "react-router";

const Key = {
  enter: 13,
  esc: 27,
  space: 32
};

export function TableRow({
  href,
  to,
  onClick,
  children,
  dragData,
  disabled = false,
  onDrop = () => void 0,
  // eslint-disable-next-line no-unused-vars
  staticContext, // https://stackoverflow.com/questions/49358560/react-wrapper-react-does-not-recognize-the-staticcontext-prop-on-a-dom-elemen
  ...props
}) {
  const history = useHistory();
  const row = useRef();
  const isLink = () => (!!href || !!to || !!onClick) && !disabled;
  const isDraggable = () => !!dragData && !disabled;

  const onclick = ev => {
    const fullPath = to ? history.createHref({ pathname: to }) : undefined;
    if (ev.altKey || ev.metaKey) return window.open(href || fullPath, "_blank");
    if (href) return (window.location.href = href);
    if (to) return history.push(to);
  };

  const onkeydown = event => {
    if (event.target !== row.current) return;
    if (event.keyCode !== Key.enter) return;
    if (onClick) return onClick(event);
    onclick(event);
  };

  const ondragstart = ev => {
    try {
      const crt = row.current.cloneNode(true);
      crt.style.border = "1px solid #edeff0";
      crt.style.backgroundColor = "white";
      crt.style.position = "absolute";
      crt.style.left = "-999999px";
      crt.id = "proxyElement";
      document.body.appendChild(crt);
      ev.dataTransfer.setDragImage(crt, 0, 0);

      ev.dataTransfer.setData("application/json", JSON.stringify(dragData));
      ev.dataTransfer.effectAllowed = "move";
    } catch (_err) {
      // eslint-disable-next-line no-console
      console.error("Failed to set drag data.");
    }
  };

  const ondragover = ev => ev.preventDefault();

  const ondrop = ev => {
    ev.preventDefault();
    try {
      let data = ev.dataTransfer.getData("application/json");
      onDrop(null, JSON.parse(data), dragData);
    } catch (err) {
      onDrop(err, null, dragData);
    }
  };

  const ondragend = ev => {
    ev.preventDefault();
    try {
      document.body.removeChild(document.getElementById("proxyElement"));
    } catch {
      // no op
    }
  };

  return (
    <tr
      className={[styles.Row, props.className].join(" ")}
      tabIndex={isLink() ? 0 : null}
      role={isLink() ? "link" : null}
      onClick={isLink() ? onClick || onclick : () => void 0}
      onKeyDown={isLink() ? onkeydown : () => void 0}
      draggable={isDraggable()}
      onDragStart={isDraggable() ? ondragstart : () => void 0}
      onDragOver={isDraggable() ? ondragover : () => void 0}
      onDrop={isDraggable() ? ondrop : () => void 0}
      onDragEnd={isDraggable() ? ondragend : () => void 0}
      title={href || to || ""}
      disabled={disabled}
      aria-disabled={disabled}
      style={props.style}
      ref={row}
    >
      {children}
    </tr>
  );
}
